export const Logo = ({ className = "h-16", testId = "header-logo" }) => (
  <img
    data-testid={testId}
    src="/logo-mc-sm.png"
    alt="MC Anime - Games - TCG & Shop"
    className={`${className} w-auto max-w-full object-contain`}
  />
);
